import { createTranslations } from '@npco/utils-translations'

export const translations = createTranslations({
  rangeLimit: 'You may choose up to 365 days for filtered data.',
})
